export const VERSION = '08fe228e7c16e8197fcf5d98a5ef847f739105ba404ef45b30f8f7ced245cb64';
